import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import BaseAnswer from '../base-answer';
import { AnswerProvider, FeedbackAnswerSurvey } from '../../providers/answer-provider';
import { FeedbackQuestionSurvey } from '../../providers/question-provider';
import { FeedbackQuestionFactoryService } from '../../questions/feedback-question-factory.service';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FeedbackQuestionService } from '../../questions/feedback-question.service';
import { MatRadioModule } from "@angular/material/radio";
import { NgForOf } from "@angular/common";
import { FlexLayoutModule } from "@angular/flex-layout";
import { TranslateModule } from "@ngx-translate/core";
import { MatIcon } from "@angular/material/icon";
import { MatButton } from "@angular/material/button";
import { Feedback } from "../../../common/models/feedback";

@Component({
  selector: 'app-feedback-bool-answer',
  templateUrl: 'feedback-bool-answer.component.html',
  styleUrls: ['./feedback-bool-answer.css', './../feedback-answer.css'],
  imports: [
    ReactiveFormsModule,
    MatRadioModule,
    NgForOf,
    FlexLayoutModule,
    TranslateModule,
    MatIcon,
    MatButton,
  ],
  standalone: true
})
export class FeedbackBoolAnswerComponent extends BaseAnswer implements OnInit {
    public form: FormGroup;

    @Input()
    public override hasAnsweredQuestion = false;

    @Input()
    public override feedback: Feedback = {} as Feedback;

    @Input()
    public override question: FeedbackQuestionSurvey = {} as FeedbackQuestionSurvey;

    @Output()
    public override onAnswerChange: EventEmitter<any> = new EventEmitter();

    @Input()
    public override previousAnswers: any = null;

    @Input()
    public answeredAnswers: any = null;

    @Output()
    public override onNextQuestionClicked: EventEmitter<{answers: FeedbackAnswerSurvey[]; isBack: boolean}> = new EventEmitter();

    public selectedAnswer: any | null = null;

    constructor(
        public override answerProvider: AnswerProvider,
        public override feedbackQuestionFactoryService: FeedbackQuestionFactoryService,
        public override feedbackQuestionService: FeedbackQuestionService,
        private fb: FormBuilder
    ) {
        super(answerProvider, feedbackQuestionFactoryService, feedbackQuestionService);

        this.form = this.fb.group({
            bool: new FormControl(null),
        });
    }

    public override ngOnInit(): void {
        super.ngOnInit();

        // find all answers for this question
        const data: any = this.feedbackQuestionService.getAnsweredAnswersByQuestionId(this.question['id']);
        this.selectedAnswer = data && data['answers'].length > 0 ? data['answers'][0] : null;

        if (this.selectedAnswer) {
            this.answerChanged(this.selectedAnswer);
        }
    }
}
